import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useTrpc } from '~/composables/_next/useTrpc';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useCategory(id) {
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var categories = useState("useCategory-categories-".concat(id), function () {
    return [];
  });
  var loading = useState("useCategory-loading-".concat(id), function () {
    return false;
  });
  var error = useState("useCategory-error-".concat(id), function () {
    return {
      search: null
    };
  });
  function search(_x) {
    return _search.apply(this, arguments);
  }
  function _search() {
    _search = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(searchParams) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return client.commercetools.getCategories.query(_objectSpread({
              locale: locale
            }, searchParams));
          case 4:
            categories.value = _context.sent;
            error.value.search = null;
            _context.next = 15;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            error.value.search = _context.t0;
            console.error("useCategory/".concat(id, "/search"), _context.t0);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('searchParams', searchParams);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('searchType', "useCategory/".concat(id, "/search"));
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context.t0);
          case 15:
            _context.prev = 15;
            loading.value = false;
            return _context.finish(15);
          case 18:
            return _context.abrupt("return", categories.value);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8, 15, 18]]);
    }));
    return _search.apply(this, arguments);
  }
  return {
    categories: readonly(categories),
    loading: readonly(loading),
    error: readonly(error),
    search: search
  };
}